import axios from "../../common/api/axios";
import Timesheet from "./interface";

export const getAllTimesheets = async (): Promise<Timesheet[]> => {
    const response = await axios.get('/timesheet');
    return response.data;
  };
  